import { environment } from '../../environments/environment';
import { isDevDataTarget } from './data-target';

const DEV_THEME_COLOR = '#f59e0b';
const PROD_THEME_COLOR = '#eeeeee';

const DEV_FAVICON_SVG =
  'data:image/svg+xml,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <rect width="64" height="64" rx="12" fill="#f59e0b"/>
      <text x="32" y="44" font-family="system-ui,sans-serif" font-size="30" font-weight="700" text-anchor="middle" fill="#1a1200">D</text>
    </svg>`,
  );

/**
 * Applies environment-driven branding so DEV can never be visually confused with PROD.
 *
 * Two independent things are branded:
 *  - the BUILD (build-time environment file, swapped via angular.json fileReplacements): PWA
 *    manifest / install name;
 *  - the DATA TARGET (runtime PROD/DEV database choice, see data-target.ts): favicon, theme-color and
 *    the `data-dev` class that drives the on-screen DEV DATABASE indicator.
 * The browser tab title is NOT branded here — it's kept short (page name, or note title / "Edit:
 * <note title>") by each page itself via `Title.setTitle()`; the env-badges pills in the header are
 * the DEV/PROD indicator, not the tab title.
 */
export function applyEnvironmentBranding(): void {
  const isDevBuild = !environment.production;
  const isDevData = isDevDataTarget();

  document.documentElement.classList.toggle('data-dev', isDevData);
  document.documentElement.classList.toggle('data-prod', !isDevData);

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  themeColorMeta?.setAttribute('content', isDevData ? DEV_THEME_COLOR : PROD_THEME_COLOR);

  const appleTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  appleTitleMeta?.setAttribute('content', isDevBuild ? 'Notes DEV' : 'Notes');

  const manifestLink = document.querySelector('link[rel="manifest"]');
  manifestLink?.setAttribute('href', isDevBuild ? 'manifest.dev.json' : 'manifest.json');

  const faviconLink = document.querySelector('link[rel="icon"]');
  if (isDevData) {
    faviconLink?.setAttribute('href', DEV_FAVICON_SVG);
  }
}
